function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist') || '[]');
}

function saveWishlist(list) {
  localStorage.setItem('wishlist', JSON.stringify(list));
}

function toggleWishlist(btn) {
  const id = btn.dataset.productId;
  let list = getWishlist();
  if (list.includes(id)) {
    list = list.filter(i => i !== id);
    btn.classList.remove('is-wishlisted');
  } else {
    list.push(id);
    btn.classList.add('is-wishlisted');
  }
  saveWishlist(list);
  updateWishlistCount();
}

function initWishlistButtons() {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const id = btn.dataset.productId;
    if (getWishlist().includes(id)) {
      btn.classList.add('is-wishlisted');
    }
  });
}

function updateWishlistCount() {
  const count = getWishlist().length;
  document.querySelectorAll('.wishlist-count').forEach(el => {
    el.textContent = count > 0 ? count : '';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  updateWishlistCount();

  // 付属商品など非同期で追加される要素を監視
  const observer = new MutationObserver(() => {
    initWishlistButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

